import departmentsApi from '../../../Api/axios/departments-api';

const useUpdate = ({ data, cancel, allDepartments, setAllDepartments }) => {
  const handleClick = async () => {
    const state = !(data[1] === 'Activo');
    const id = data[2];
    try {
      await departmentsApi.patch(id, { status: state });
      const newAllDepartments = allDepartments.map(department => {
        if (department[2] === id) {
          return [department[0], state ? 'Activo' : 'Inactivo', department[2]];
        }
        return department;
      });
      setAllDepartments(newAllDepartments);
    } catch (error) {
      console.error(error);
    } finally {
      cancel();
    }
  };

  return {
    handleClick,
  };
};

export default useUpdate;
